<div *transloco="let t">
	<vex-page-layout mode="card">
		<vex-page-layout-header class="pb-16 flex flex-col justify-center items-start">
			<div class="mt-4">
				<h1 class="title mt-0 mb-1">{{ t('uvi.consumptionInformation') }}</h1>
				<vex-breadcrumbs [crumbs]="breadCrumbService.crumbs"></vex-breadcrumbs>
			</div>
		</vex-page-layout-header>
		<vex-page-layout-content class="-mt-6">
			<ara-tenant-detail-cards></ara-tenant-detail-cards>

			<div #swipeWrapper class="card mt-4 p-4 md:p-6">
				<div class="flex flex-row flex-wrap items-center justify-between gap-4">
					<mat-form-field appearance="outline" subscriptSizing="dynamic" class="uvi-date-field">
						<mat-label>{{ t('massPrint.dates') }}</mat-label>
						<mat-select name="dateSelect" [disabled]="!dateOptions().length" [(ngModel)]="model.selectedDate" (selectionChange)="dateChanged()">
							@for (option of dateOptions(); track option.date) {
								<mat-option [value]="option.date" [disabled]="!option.hasReport">
									{{ option.date | date: 'MMMM yy' : '' : locale }}
									@if (!option.hasReport) {
										<span class="text-black/45">&ndash; {{ t('uvi.monthWithoutReport') }}</span>
									}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>

					<div class="flex flex-row items-center gap-2">
						@if (isRoleSupport()) {
							<button
								(click)="refreshUvi()"
								[disabled]="!model.selectedDate"
								[matTooltip]="t('uvi.recalculate')"
								[attr.aria-label]="t('uvi.recalculate')"
								color="primary"
								mat-icon-button
								type="button">
								<mat-icon [svgIcon]="icons.get('recalculate')"></mat-icon>
							</button>
						}
						<!-- hide printbutton for specific austrian customer -->
						<button
							(click)="printUvi()"
							[hidden]="sessionService.effectiveArea === 111"
							[disabled]="!hasConsumptionData()"
							[matTooltip]="t('uvi.print')"
							color="primary"
							mat-raised-button
							type="button">
							<mat-icon [svgIcon]="icons.get('print')"></mat-icon>
							@if (!layoutService.isMobile()) {
								<span class="ml-1">{{ t('uvi.print') }}</span>
							}
						</button>
					</div>
				</div>

				<mat-divider class="my-4"></mat-divider>

				@if (!finishedLoading()) {
					<div @fadeInUp class="flex flex-row justify-center py-10">
						<mat-spinner color="primary"></mat-spinner>
					</div>
				} @else if (!hasConsumptionData()) {
					<div @fadeInUp class="flex flex-col items-center justify-center py-10 text-center">
						<mat-icon class="text-gray-400 text-4xl w-9 h-9 mb-2.5" fontSet="material-symbols-outlined">info</mat-icon>
						<span>{{ t(emptyStateKey()) }}</span>
					</div>
				} @else if (calculationVersionType === CalculationVersionTypeEnum.V1) {
					<chart-display
						[currentRealEstate]="currentRealEstate()"
						[currentTenantUnit]="currentTenantUnit()"
						[inputDate]="model.selectedDate"></chart-display>
				} @else {
					@for (consumption of consumptions; track consumption) {
						@if (consumption.costType) {
							<div class="rounded-xl border p-3 md:p-6 mb-4 last:mb-0">
								<div class="flex flex-row">
									<div class="headline w-[40%] flex flex-row" style="align-items: center">
										<mat-icon [svgIcon]="getIconByCostType(consumption.costType)" class="title-icon" id="icHeating"></mat-icon>
										<h2 class="ml-4">{{ getLabelByCostType(consumption.costType) }}</h2>
									</div>
								</div>
								<div class="p-2">
									<mat-tab-group name="matTabGroup" [mat-stretch-tabs]="false">
										@if (showChart()) {
											<mat-tab label="{{ t('uvi.consumptionInformation') }}" [labelClass]="layoutService.isMobile() ? 'px-2' : ''">
												<ng-template matTabContent>
													<vex-chart-display-per-energytype
														[date]="model.selectedDate"
														[consumption]="consumption"></vex-chart-display-per-energytype>
												</ng-template>
											</mat-tab>
										}
										@if (showPercentutal()) {
											<mat-tab label="{{ t('uvi.readingValueInformation') }}" [labelClass]="layoutService.isMobile() ? 'px-2' : ''">
												<ng-template matTabContent>
													<vex-percent-display-per-energytype [consumption]="consumption"></vex-percent-display-per-energytype>
												</ng-template>
											</mat-tab>
										}
									</mat-tab-group>
								</div>
							</div>
						}
					}
				}
			</div>
		</vex-page-layout-content>
	</vex-page-layout>
</div>
